import { render, staticRenderFns } from "./BlujayBcaTransactionDetail.vue?vue&type=template&id=0fd1594a&scoped=true&"
import script from "./BlujayBcaTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./BlujayBcaTransactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlujayBcaTransactionDetail.vue?vue&type=style&index=0&id=0fd1594a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1594a",
  null
  
)

export default component.exports